/**
 * The PaletteCtx (§12.1) built from the app's stores at the moment of a query.
 * `nav` (the §3.5 open functions) and `palette` (the palette's own controller:
 * setScope / setQuery / close — used by "enter scope" and help rows) are
 * injected by the component, so providers stay testable with fakes.
 */
import { isWebApp } from '../platform/target';
import { useUiModalStore } from '../store/uiModalStore';
import { useTeamsStore } from '../store/teamsStore';
import { useAuthStore } from '../store/authStore';
import { useWorkspaceStore } from '../store/workspaceStore';
import { useProjectScopeStore } from '../scope/projectScopeStore';
import { useVaultStore } from '../store/vaultStore';
import { personalScopeId } from '../services/personalScope';
import { deviceScopeId } from '../records/itemLocation';

/** Record scopes the user may search NOW: personal, device, one per current team. */
export function currentScopes() {
  const teams = useTeamsStore.getState().teams || [];
  const scopes = [personalScopeId()];
  const device = deviceScopeId();
  if (device) scopes.push(device);
  for (const t of teams) if (t?.id != null) scopes.push(`team:${t.id}`);
  return scopes;
}

export function buildPaletteCtx({ t, nav = {}, palette = {}, signedIn = true } = {}) {
  const teams = useTeamsStore.getState().teams || [];
  const user = useAuthStore.getState().user;
  const ws = useWorkspaceStore.getState().currentWorkspace;
  return {
    platform: isWebApp() ? 'web' : 'desktop',
    signedIn,
    online: typeof navigator === 'undefined' ? true : navigator.onLine !== false,
    activeTab: useUiModalStore.getState().activeTab,
    scopes: currentScopes(),
    teamIds: teams.map((x) => String(x.id)),
    currentWorkspaceId: ws?.id != null ? String(ws.id) : null,
    activeProjectId: useProjectScopeStore.getState().activeProjectId || 'all',
    vaultUnlocked: !!useVaultStore.getState().status?.unlocked,
    currentUserId: user?.id != null ? String(user.id) : null,
    t: t || ((k) => k),
    nav,
    palette,
  };
}
